/*
 * Public API Surface of shared-models
 */

export type { EnvironmentModel } from './lib/infrastructure/interfaces/environment.interface';
export { TranslationLanguage } from './lib/infrastructure/enums/translation-language.enum';

export type { WorkPackage } from './lib/work-packages/interfaces/work-package.interface';
export { WorkPackageStatus } from './lib/work-packages/enums/work-package-status.enum';

export type { Client } from './lib/clients/interfaces/client.interface';
export { ClientStatus } from './lib/clients/enums/client-status.enum';

export { SshKeyStatus } from './lib/ssh-keys/enums/ssh-key-status.enum';

export { OperationStatus, OperationFileStatus } from './lib/operation-status';

export { ShareStatus } from './lib/sharing/operation-share';
export type { OperationShareInfo, RecipientKeyRef, InvalidRecipient } from './lib/sharing/operation-share';
export { SHARE_EXPIRY_PRESETS, SHARE_EXPIRY_DEFAULT_DAYS } from './lib/sharing/share-recipient';
export type { ShareRecipient, ShareExpiryPreset } from './lib/sharing/share-recipient';
export type { IncomingShare, IncomingShareFile, IncomingSharesResponse, ShareReceivedDto } from './lib/sharing/incoming-share';
export type { HistoricalShare, HistoricalSharesResponse } from './lib/sharing/historical-share';
